<div class="modal-header">
    <h5 class="modal-title">{{ title }}</h5>
    @if (summary) {
        <div class="summary-badges ml-3">
            <span class="badge badge-light border mr-1">{{ summary.totalInFile }}&nbsp;{{ 'Total' | translate }}</span>
            <span class="badge badge-success mr-1">{{ summary.successCount }}&nbsp;{{ 'Successful' | translate }}</span>
            <span class="badge badge-danger">{{ summary.failedCount }}&nbsp;{{ 'Failed' | translate }}</span>
        </div>
    }
    <button class="close ml-auto" type="button" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    @if (errors?.length) {
        <div class="filter-row">
            <div class="row align-items-center">
                <div class="col-3">
                    <form-dropdown
                        labelText="{{ 'Severity' | translate }}"
                        [codeListValues]="severityCodeListValues"
                        [(ngModel)]="filterSeverity"
                        (valueChange)="applyFilter()"></form-dropdown>
                </div>
                <div class="col-9">
                    <form-textbox
                        labelText="{{ 'Search' | translate }}"
                        [(ngModel)]="searchText"
                        (ngModelChange)="applyFilter()"></form-textbox>
                </div>
            </div>
        </div>
    }

    @if (filteredErrors?.length) {
        <div class="errors-container">
            <table class="table table-stripped table-bordered">
                <thead>
                    <tr>
                        <th style="width: 36px"></th>
                        <th style="width: 140px">{{ 'Container' | translate }}</th>
                        <th>{{ 'Message' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    @for (err of filteredErrors; track err) {
                        <tr>
                            <td class="text-center">
                                <fa-icon
                                    [icon]="getSeverityIcon(err.severity)"
                                    [class]="getSeverityClass(err.severity)"
                                    [title]="err.identificator"></fa-icon>
                            </td>
                            <td>{{ err.containerNumber || ('General' | translate) }}</td>
                            <td>{{ err.message }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    } @else {
        @if (noResults) {
            <div class="text-center py-4">
                <fa-icon class="mb-2" size="2x" [icon]="['fas', 'search']"></fa-icon>
                <p>{{ 'No records match the current filter or search.' | translate }}</p>
            </div>
        }
        @if (!noResults && !hasErrors) {
            <div class="text-center text-muted py-4">
                <fa-icon class="text-success mb-2" size="2x" [icon]="['fas', 'check-circle']"></fa-icon>
                <p>{{ 'All containers imported successfully with no errors.' | translate }}</p>
            </div>
        }
    }
</div>

<div class="modal-footer">
    <button class="btn btn-sm btn-secondary" type="button" (click)="close()">
        {{ 'OK' | translate }}
    </button>
</div>
